import { Link } from "react-router-dom";
import { SOLUTIONS } from "@/lib/solutions";

export const PublicFooter = () => (
  <footer className="border-t border-[var(--line)] bg-[var(--surface-2)]">
    <div className="mx-auto max-w-7xl px-6 py-12 md:px-10">
      <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
        <div className="col-span-2 sm:col-span-1">
          <p className="font-display text-lg tracking-tight">Customize Studio</p>
          <p className="mt-2 text-sm text-[var(--ink-soft)]">
            AI before &amp; after visualization for home improvement sales teams.
          </p>
        </div>
        <div>
          <p className="overline">Solutions</p>
          <ul className="mt-3 space-y-2">
            {SOLUTIONS.map((s) => (
              <li key={s.slug}>
                <Link to={`/solutions/${s.slug}`} data-testid={`footer-link-${s.slug}`}
                  className="text-sm text-[var(--ink-soft)] transition-colors hover:text-[var(--brand)]">
                  {s.keyword}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="overline">Product</p>
          <ul className="mt-3 space-y-2">
            <li><Link to="/signup" className="text-sm text-[var(--ink-soft)] hover:text-[var(--brand)]">Get Started</Link></li>
            <li><Link to="/login" className="text-sm text-[var(--ink-soft)] hover:text-[var(--brand)]">Log in</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline">Company</p>
          <ul className="mt-3 space-y-2">
            <li><Link to="/solutions" className="text-sm text-[var(--ink-soft)] hover:text-[var(--brand)]">All solutions</Link></li>
            <li><Link to="/journal" data-testid="footer-journal" className="text-sm text-[var(--ink-soft)] hover:text-[var(--brand)]">Journal</Link></li>
            <li><Link to="/" className="text-sm text-[var(--ink-soft)] hover:text-[var(--brand)]">Home</Link></li>
          </ul>
        </div>
      </div>
      <p className="mt-10 text-xs text-[var(--ink-soft)]">
        © {new Date().getFullYear()} Customize Studio. AI visualization software for home improvement remodelers.
      </p>
    </div>
  </footer>
);
